import { ShieldCheck, Lock, Award, AlertTriangle } from "lucide-react";

const BADGES = [
  { icon: ShieldCheck, title: "Conformidade LGPD", desc: "Seus dados são tratados conforme a Lei Geral de Proteção de Dados." },
  { icon: Lock, title: "Conexão SSL Segura", desc: "Certificado SSL 256-bit protege todas as informações trafegadas." },
  { icon: Award, title: "Satisfação Garantida", desc: "Suporte prioritário e acompanhamento humano em cada etapa." },
];

export default function TrustSection() {
  return (
    <section className="py-20 lg:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12">
          {BADGES.map((b) => (
            <div key={b.title} data-testid={`trust-badge-${b.title.toLowerCase().replace(/\s/g, "-")}`} className="flex gap-4 rounded-2xl border border-slate-200 bg-slate-50 p-6">
              <span className="grid place-items-center h-12 w-12 rounded-xl bg-emerald-100 text-emerald-600 shrink-0"><b.icon className="h-6 w-6" /></span>
              <div>
                <h3 className="font-heading font-bold text-slate-900">{b.title}</h3>
                <p className="text-sm text-slate-600 mt-1 leading-relaxed">{b.desc}</p>
              </div>
            </div>
          ))}
        </div>

        <div data-testid="legal-disclaimer" className="rounded-2xl border border-amber-200 bg-amber-50 p-6 sm:p-8 flex gap-4">
          <AlertTriangle className="h-6 w-6 text-amber-600 shrink-0 mt-0.5" />
          <div>
            <h3 className="font-heading font-bold text-amber-900 mb-2">Aviso Legal — Isenção de Responsabilidade</h3>
            <p className="text-sm text-amber-900/90 leading-relaxed">
              A <strong>Central de Serviços do MEI</strong> é uma empresa privada de assessoria e consultoria administrativa.
              <strong> Não possuímos vínculo direto com órgãos governamentais</strong> (Receita Federal, Governo Federal ou DETRAN).
              Os serviços fornecidos são de intermediação e facilitação burocrática, mediante cobrança de honorários de assessoria.
              Os serviços governamentais também podem ser realizados <strong>gratuitamente</strong> nos canais oficiais do governo.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
